import * as React from "react";
const SvgNetworkCellOutlined = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <path fill="none" d="M0 0h24v24H0V0z" />
    <path d="M2 22h20V2L2 22zm18-2h-3V9.83l3-3V20z" />
  </svg>
);
export default SvgNetworkCellOutlined;
